module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/R9dH8j/tc-custom/9781473854932.jpg?1703823904940",
      "alt": "This image is the cover for the book Hamilton & Gallipoli"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hamilton & Gallipoli\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This is a study of Sir Ian Hamilton VCs command of the Gallipoli campaign. Appointed by Kitchener after the failure of the initial Allied naval offensive in the Dardanelles, Hamilton was to lead the ambitious amphibious landings that were intended to open the way to Constantinople. In the event, however, opportunities immediately after the landings were squandered and, in the face of unexpectedly effective Turkish resistance, soon stalled in attritional trench warfare like that on the Western Front. Hamilton has often been criticized for this failure and in many ways seen to typify the stereotype of a British general clinging to outdated Victorian thinking. Yet this fresh reappraisal, drawing on original archival research, shows that Hamilton did display some progressive ideas and a realization that warfare was rapidly changing. Like all generals of this period he faced the challenge of unprecedented technological and tactical revolution as well as the political and media battle. It is as a case study of command in these circumstances that Evan Mcgilvray's assessment of Hamilton will be most valued.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Evan McGilvray\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Evan McGilvray has written several books on Polish military history for Helion and is writing a book about Poland, NATO and the failure of democracy in Poland since joining the European Union.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0